// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderDesktop_header__3tMWV","right":"HeaderDesktop_right__3x_KP","logo":"HeaderDesktop_logo__QDEVD"};